import './styles/tokens.css';
import './styles/app.css';
import './styles/timeline.css';
import './styles/print.css';

import { mountShell } from './app/shell';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('#app root element is missing from index.html');

mountShell(root);
